import MFEBus from './MFEBus'

const MFEStore = (() => {
  let s = { activeSection: 'home', navOpen: false, sphereMode: 0, theme: 'dark' }
  const subs = new Set()
  function get() { return s }
  function set(partial) {
    s = { ...s, ...partial }
    subs.forEach(fn => fn(s))
    MFEBus.emit('store:update', partial)
  }
  function subscribe(fn) { subs.add(fn); return () => subs.delete(fn) }
  return { get, set, subscribe }
})()

export default MFEStore
